import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { Product } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface UpdateProductUseCase {
  invoke: (product: Product) => Promise<ResponseState<Message>>;
}

export class UpdateProductUseCaseImpl implements UpdateProductUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(product: Product): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.update(product);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
